module.exports = __webpack_public_path__ + "images/embed/shadowlight1.gif";